export default __webpack_public_path__ + "static/media/location.e9cd8f65.PNG";